<template>
    <div class="white-list-add-dialog-box"> 
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="600px"
            custom-class="white-list-add-dialog-class" 
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :destroy-on-close="true"
            :before-close="close"
            @close="close"
        > 
        <div class="white-list-content">
            <el-form size="small" ref="form" :model="formData" :rules="rules" label-width="100px">
                <el-form-item label="白名单IP" prop="ip_address">
                    <el-input size="small" v-model="formData.ip_address" placeholder="请输入白名单IP"></el-input>
                    <div class="form-tips">提示：请输入一个白名单IP</div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close">取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="suer" :disabled="loading">确定</el-button>
           
        </div>
        </el-dialog>
    </div>
</template>
<script>
    export default{
        props:{
            dialogVisible:{
                type: Boolean,
                default:false
            },
            title:{
                type: String,
                default: ''
            },

            whiteListData:{
                type: Object,
                default: () => {}
            },
            loading:{
                type: Boolean,
                default:false
            }
        },
        data() { 
            return{ 
                formData:{
                    ip_address:'',
                },
                rules:{
                    ip_address:[
                        { required: true, message: '请输入白名单IP', trigger: 'blur' }
                    ],
                }
            }
        },
        mounted() { 
            this.formData = {...this.formData,...this.whiteListData}
            // this.formData.ip_address= this.whiteListData.ip
            console.log(this.formData)
        },
        methods:{
            close(){
                this.$refs.form.resetFields()
                this.$emit('close')
            },
            suer(){
                this.$refs.form.validate(async valid => {
                    if (valid) {
                        console.log('===',this.formData)
                        this.$emit('sure',this.formData)
                    } else {
                        return false;
                    }
                })
            }
        },
    }
</script>
<style scoped lang="scss">
    .white-list-add-dialog-class{
        .form-tips {
            color: #909399;
            font-size: 12px;
            margin-top: 8px;
        }
    }

</style>